module.exports = __webpack_public_path__ + "img/portrait-058.37cd2080.jpg";